import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.15 Pentru cei dragi ── */
export function HomeForDear() {
  const c = useSectionContent("home_for_dear");
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-3xl mx-auto px-5 text-center">
        <Users size={28} className="mx-auto mb-4" style={{ color: "var(--ct-link)" }} />
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Nu pentru tine, ci pentru cineva drag?"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-4">{c.title || "Suferă cineva la care ții?"}</h2>
        <p data-el="body" data-field="body" className="text-base leading-relaxed mb-7 max-w-xl mx-auto" style={{ color: "var(--ct-text-muted)" }}>
          {c.body || "E greu să privești neputincios pe cineva drag prăbușindu-se — un părinte, un partener, un copil. Nu poți vindeca în locul lui, dar poți face diferența dintre a-l împinge și a-i fi alături. Hai să vorbim despre cum."}
        </p>
        <Link data-el="cta" data-field="cta" to="/contact" className="btn-gold">{c.cta || "Vreau să-l ajut, fără să-l pierd"} <ArrowRight size={15} /></Link>
      </div>
    </section>
  );
}
